import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/quickBetCardMarbles.css';
import {ASSETS_URL} from "../../../constants/endpoints";
import {getGameFromChannel} from "../helpers/gameHelpers";
import {sortRacers} from "../modules/racing/helpers/sortingHelper";
import {TO_WIN, TO_WIN_EW} from "../modules/racing/constants/identifiers";
import SingleButton from "../modules/racing/components/singleButton";
import {addOpenBet, removeOpenBet} from "../actions/openBetsActions";
import {getOddsFromOddsType} from "../../../helpers/oddsHelpers";
import {NMB, PRE} from "../../../constants/identifiers";
import {getText} from "../../../helpers/localization";
import {calculateTimeDifference, formatTimeInSecondsToS} from "../../../helpers/helperFunctions";
import {isMarbleEuroEvent} from '../modules/racing/helpers/racersHelper';
import device from 'current-device';
import eventLiveCounter from "./eventLiveCounter";


const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedGameIndex: state.vpp.selectedGameIndex,
        openBetsList: state.vpp.openBetsList,
        selectedRaceCardSortField: state.vpp.selectedRaceCardSortField,
        selectedOddsType: state.vpp.selectedOddsType,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        serverTimeOffset: state.vpp.serverTimeOffset,
        systemLanguage: state.vpp.systemLanguage
    };
};

class QuickBetCardMarbles extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.isEventLive = false;
        this.marbleClickArray = [];
        this.state = {
            games: storeData.vpp.games,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage,
            timeLeft: this._getTimeLeft(),
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
        };
    }


    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    _getTimeLeft() {
        let nextEventTime = this._getNextEventTime();
        if (nextEventTime !== undefined) {
            let timeLeft = calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), nextEventTime) / 1000;
            if (Math.floor(timeLeft) === 0) {
                setTimeout(() => this.isEventLive = true, 200);
                setTimeout(() => this.isEventLive = false, 2000);
            }
            return timeLeft;
        }
        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    _checkIfButtonsEnabled() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        if (selectedEvent) {
            for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
                if (storeData.vpp.noMoreBetsEventList[i].eventId === selectedEvent.eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    if (selectedGame.controllerState === NMB || selectedGame.controllerState === PRE) {
                        return false;
                    }
                    break;
                }
            }
        }
        return true;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _getNextEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((event) => event.channel === this.state.games[this.state.selectedGameIndex].channel && Number(event.eventTime) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }
        return eventTime;
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                openBetsList: storeData.vpp.openBetsList,
                selectedRaceCardSortField: storeData.vpp.selectedRaceCardSortField,
                selectedOddsType: storeData.vpp.selectedOddsType,
                systemLanguage: storeData.vpp.systemLanguage,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
            });
        }
    }

    render() {
        let racerList = this._getRacerList();
        let timeCounter;
        if (device.mobile() && !device.tablet()) {
            if (window.screen.orientation && window.orientation !== undefined) {
                if (window.orientation === -90 || window.orientation === 90) {
                    timeCounter = (
                        <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>);
                }
            } else if (window.orientation !== undefined) {
                if (window.orientation === -90 || window.orientation === 90) {
                    timeCounter = (
                        <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>);
                }
            }
        }
        return (
            <div id={'main_container'} className={style.mainContainer}>
                {this._getMainContainerUI(racerList, timeCounter)}
                <div id={'win_streak'} className={style.winStreakContainer}>
                    <div id={'racer_win_1'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[0])}
                    </div>
                    <div id={'racer_win_2'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[1])}
                    </div>
                    <div id={'racer_win_3'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[2])}
                    </div>
                    <div id={'racer_win_4'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[3])}
                    </div>
                    <div id={'racer_win_5'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[4])}
                    </div>
                    <div id={'racer_win_6'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[5])}
                    </div>
                    <div id={'racer_win_7'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[6])}
                    </div>
                    <div id={'racer_win_8'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[7])}
                    </div>
                    <div id={'racer_win_9'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[8])}
                    </div>
                    <div id={'racer_win_10'} className={style.racerCell}>
                        {this._getWinRacerIcon(racerList[9])}
                    </div>
                </div>
            </div>)
    }

    _getMainContainerUI(racerList, timer) {
        let isEnabled = this._checkIfButtonsEnabled();
        let nmbText = isEnabled ? getText('SELECT_YOUR_BET_BELOW', this.props.store)
            : getText('NO_MORE_BETS', this.props.store);
        return timer ? (
            <Fragment>
                {timer}
            </Fragment>
        ) : (
            <Fragment>
                <div id={'nmb_container'} className={style.nmbContainer}>{nmbText}</div>
                <div className={style.quickBetContainer}>
                    <div id={'racer_row1'} className={style.quickBetRow}>
                        <div id={'racer_col_f1'} className={style.quickBetColSmall}></div>
                        <div id={'racer_col_1'}
                             className={style.quickBetColLarge}>{this._getRacerButton(racerList[0])}</div>
                        <div id={'racer_col_2'}
                             className={style.quickBetColLarge}>{this._getRacerButton(racerList[1])}</div>
                        <div id={'racer_col_3'}
                             className={style.quickBetColLarge}>{this._getRacerButton(racerList[2])}</div>
                        <div id={'racer_col_l1'} className={style.quickBetColSmall}></div>
                    </div>
                    <div id={'racer_row2'} className={style.quickBetRow}>
                        <div id={'racer_col_4'}
                             className={style.quickBetColSmall}>{this._getRacerButton(racerList[3])}</div>
                        <div id={'racer_col_5'}
                             className={style.quickBetColSmall}>{this._getRacerButton(racerList[4])}</div>
                        <div id={'racer_col_6'}
                             className={style.quickBetColSmall}>{this._getRacerButton(racerList[5])}</div>
                        <div id={'racer_col_7'}
                             className={style.quickBetColSmall}>{this._getRacerButton(racerList[6])}</div>
                    </div>
                    <div id={'racer_row3'} className={style.quickBetRow}>
                        <div id={'racer_col_f2'} className={style.quickBetColSmall}></div>
                        <div id={'racer_col_8'}
                             className={style.quickBetColLarge}>{this._getRacerButton(racerList[7])}</div>
                        <div id={'racer_col_9'}
                             className={style.quickBetColLarge}>{this._getRacerButton(racerList[8])}</div>
                        <div id={'racer_col_10'}
                             className={style.quickBetColLarge}>{this._getRacerButton(racerList[9])}</div>
                        <div id={'racer_col_l2'} className={style.quickBetColSmall}></div>
                    </div>

                </div>
            </Fragment>
        )
    }

    _getRacerList() {
        if (this.state.events.length > 0 && this.state.events[this.state.selectedEventIndex].racers !== undefined) {
            return this.state.events[this.state.selectedEventIndex].racers.sort(sortRacers.bind(this.state));
        } else {
            return [];
        }
    }

    _getRacerButton(racer) {
        let bet = this._isChecked(racer);
        let isChecked = bet !== undefined;
        let isEnabled = this._checkIfButtonsEnabled();
        this.marbleClickArray.push({num: racer.num, value: false});
        let onClick = (racer) => {
            if (!isEnabled) {
                return;
            }
            !isChecked
                ? this._placeBet(racer, TO_WIN.code + '-' + racer.num, racer.num)
                : this._removeBet(bet);
        }

        let isCheckedStyle = isChecked
            ? style.checked
            : style.buttonWrapper;
        let odd = getOddsFromOddsType(racer.oddsFirst, this.state.selectedOddsType);
        let isEuroEvent = isMarbleEuroEvent(this.state.events[this.state.selectedEventIndex].eventType, this.state.games[this.state.selectedGameIndex].name);

        return (

            <div id={'racer_button_container_' + racer.num} className={style.buttonContainer}>
                <div className={style.buttonTile}>
                    <div id={'white_container_' + racer.num}
                         className={isEuroEvent ? style.whiteContainerEuroMarble : style.whiteContainer}>
                        <div id={'img_container_' + racer.num}
                             className={isEuroEvent ? style.imageHolder : style.imgContainer}>
                            <img
                                src={`${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, this.state.games).assetsPath}/silks/${isEuroEvent ? 'marbles/' : ''}silk${Number(racer.silk) + 1}.png`}
                                className={isEuroEvent ? style.marbleIconEuroMarbles : style.marbleIcon}
                                alt={`icon${racer.silk}`} onClick={() => onClick(racer)}/>
                        </div>
                        {isEuroEvent ?
                            (<div id={'flag_container_' + racer.num} className={`${style.flagImageHolder}`}>
                                <img
                                    src={`${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, this.state.games).assetsPath}/silks/${isEuroEvent ? 'flags/' : ''}silk${Number(racer.silk) + 1}.png`}
                                    className={isEuroEvent ? style.flagIconEuroMarble : style.marbleIcon}
                                    alt={`icon${racer.silk}`} onClick={() => onClick(racer)}/>
                            </div>) : ""
                        }
                        {isEuroEvent ? '' :
                            <React.Fragment>
                                <div id={'number_container_' + racer.num} className={style.numEmptyContainer}
                                     onClick={() => onClick(racer)}></div>
                                <div id={'number_container_' + racer.num} className={style.numContainer}
                                     onClick={() => onClick(racer)}>{racer.num}</div>
                            </React.Fragment>
                        }
                        <div id={'button_' + racer.num}
                             className={isEuroEvent ? style.clickContainerEuroMarble : style.clickContainer}>
                            <SingleButton
                                isQuickBet={true}
                                isClicked={this.marbleClickArray.find(obj => obj.num === racer.num).value}
                                htmlId={'racer_button_' + racer.num}
                                style={`${isCheckedStyle}`}
                                sbLabel={odd}
                                sbSub={''}
                                isChecked={isChecked}
                                isEnabled={isEnabled}
                                circleSize={'medium'}
                                racer={racer}
                                marketId={TO_WIN.code + '-' + racer.num}
                                marketNum={racer.num}
                                store={this.props.store}
                                buttonStyle={isEuroEvent ? style.buttonCustomStyleEuroMarble : style.buttonCustomStyle}
                                buttonWrapperStyle={style.buttonWrapperStyle}
                                betType={TO_WIN}
                                odd={odd}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    _getWinRacerIcon(racer) {
        let lastWin = null;
        if (this.state.games[this.state.selectedGameIndex].lastResults !== undefined && this.state.games[this.state.selectedGameIndex].lastResults != null) {
            let lastRaceResult = this.state.games[this.state.selectedGameIndex].lastResults.find((num) => num.number === racer.num);
            if (lastRaceResult !== undefined && lastRaceResult !== null) {
                lastWin = lastRaceResult.lastWin;
            }
        }
        let label;
        if (lastWin === 0) {
            label = getText('WIN_INITIAL', this.props.store);
        } else if (lastWin === undefined || lastWin === null) {
            label = getText('LOSE_INITIAL', this.props.store) + '1';
        } else {
            label = getText('LOSE_INITIAL', this.props.store) + lastWin;
        }
        let isEuroEvent = isMarbleEuroEvent(this.state.events[this.state.selectedEventIndex].eventType, this.state.games[this.state.selectedGameIndex].name);

        return (
            <div id={'racer_win_' + racer.num} className={style.winStreakButton}>
                <div id={'racer_row_' + racer.num} className={style.winStreakNumber}>
                    <div id={'racer_icon'} className={style.winStreakIconContainer}>
                        <img
                            src={`${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, this.state.games).assetsPath}/silks/${isEuroEvent ? 'combined/' : ''}silk${Number(racer.silk) + 1}.png`}
                            className={isEuroEvent ? style.marbleWinStreakIconEuroMarble : style.marbleWinStreakIcon}
                            alt={`icon${racer.silk}`}/>
                    </div>
                    {isEuroEvent ? '' :
                        <React.Fragment>
                            <div className={style.winStreakNumberContainer}>
                                <div id={'racer_number'} className={style.winRacerEmptyConatiner}></div>
                                <div id={'racer_number'} className={style.winRacerNumConatiner}>{racer.num}</div>
                            </div>
                        </React.Fragment>
                    }
                </div>
                <div id={'racer_row_2'} className={style.winStreakResult}>
                    {label}
                </div>
            </div>
        );
    }

    _isChecked(racer) {
        let openBetsList = this.state.openBetsList;
        if (openBetsList.length > 0) {
            let currentSelectedGame = this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex];
            let currentSelectedEvent = this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex];
            for (let i = 0; i < openBetsList.length; i++) {
                if (openBetsList[i].bets[0].game.channel === currentSelectedGame.channel && openBetsList[i].bets[0].event.eventId === currentSelectedEvent.eventId) {
                    if ((openBetsList[i].bets[0].betType.name === TO_WIN.name || openBetsList[i].bets[0].betType.name === TO_WIN_EW.name) && openBetsList[i].bets[0].racers[0].num === racer.num) {
                        return openBetsList[i];
                    }
                }
            }
        }
        return undefined;

    }

    _placeBet(racer, marketId, marketNum) {
        let bet = {
            game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
            event: this.props.store.getState().vpp.events[this.props.store.getState().vpp.selectedEventIndex],
            betType: TO_WIN,
            market: {
                id: marketId,
                num: marketNum
            },
            racers: [racer]
        };

        this.props.store.dispatch(addOpenBet(bet, this.state.openBetsList));
        this._updateClickStatus(racer.num, true);
        setTimeout(() => this._updateClickStatus(racer.num, false), 1000);
    }

    _updateClickStatus(racerNum, clickStatus) {
        this.marbleClickArray = this.marbleClickArray.map(obj => {
            if (obj.num === racerNum) {
                return {...obj, value: clickStatus};
            }
            return obj;
        })
    }

    _removeBet(bet) {
        this.props.store.dispatch(removeOpenBet(bet));
    }


}

export default connect(mapStateToProps)(QuickBetCardMarbles);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/quickBetCardMarbles.js